import { CurationFeedPage } from '@services/MarppleShop/renderApp/pages/Curation/CurationFeed/CurationFeed.page.ts';

export const curationFeedRouter = {
  '/@/curation-feed': CurationFeedPage,
};
